import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, retry, throwError, timer } from 'rxjs';
import { ConfigService } from '../../service/config.service';

@Injectable({
  providedIn: 'root',
})
export class RetryInterceptor implements HttpInterceptor {
  private readonly configService = inject(ConfigService);

  public intercept(
    request: HttpRequest<unknown>,
    httpHandler: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return httpHandler.handle(request).pipe(
      retry({
        count: this.configService.retryCount,
        delay: (
          error: HttpErrorResponse,
          retryCount: number
        ): Observable<unknown> => {
          if (0 === error.status || error.status >= 500) {
            return timer(1000 * retryCount);
          }
          return throwError(() => error);
        },
      })
    );
  }
}
